module.exports = __webpack_public_path__ + "static/AP-5c13f8ad48126419ac622c3f6f59e963.png";